var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.409 3.76579L9.54226 2.11956C9.45665 2.09556 9.36678 2.09556 9.28118 2.11956L3.41439 3.76579C3.17759 3.83216 3.01172 4.0689 3.01172 4.34031V9.10508C3.01172 11.9952 4.32481 14.6417 6.52406 16.1842L9.12678 18.01C9.21371 18.071 9.31265 18.1016 9.41159 18.1016C9.51052 18.1016 9.60946 18.071 9.69639 18.01L12.2994 16.1842C14.4989 14.6414 15.8117 11.9949 15.8117 9.10508V4.34031C15.8117 4.0689 15.6458 3.83216 15.409 3.76579ZM12.3199 7.70329L8.94491 11.4532C8.84091 11.5691 8.70437 11.6269 8.56783 11.6269C8.4313 11.6269 8.29476 11.5691 8.19076 11.4532L6.50326 9.57826C6.29499 9.34686 6.29499 8.97174 6.50326 8.74033C6.71126 8.50893 7.0494 8.50893 7.25741 8.74033L8.56783 10.1963L11.5658 6.86536C11.7738 6.63395 12.1119 6.63395 12.3199 6.86536C12.5282 7.09677 12.5282 7.47188 12.3199 7.70329Z",
    fill: "#20A76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeIcon);
export default __webpack_public_path__ + "static/media/safeIcon.12b8abab53059d1de67972a61a6b6c34.svg";
export { ForwardRef as ReactComponent };